module.exports = __webpack_public_path__ + "img/rinsizeMeasurement@2x.b498636.jpg";